<div class="back">
  <button type="button" class="btn btn-sm pl-0 ml-0 mb-3" (click)="goBack()">
    <span><i class="icon icon-arrow-back-breadcrumb mr-1" aria-hidden="true"></i>EXIT SEARCH</span>
  </button>
</div>

<div class='header mt-2 mb-2'>

</div>

<div class="content row" cdkDropListGroup>
	<!-- Document repository -->
	<div class="doc-repo col-4">
		<app-document-repository [allowAdd]="false"></app-document-repository>
	</div>

	<!-- Search panel -->
	<div class="submenu col-8">

	</div>
</div>

